import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Dialog, DialogActions } from '@/components/molecules/dialog';
import { useRemoveOrganizationLogo } from '@/features/settings/hooks/mutation/use-remove-organization-logo';

const RemoveOrganizationLogoDialog = ({ open, onCancel }: DialogActions) => {
  const { t } = useTranslation(['settings', 'common']);

  const { mutate, isPending } = useRemoveOrganizationLogo(onCancel);

  return (
    <Dialog
      open={open}
      onCancel={onCancel}
      onConfirm={mutate}
      isConfirmButtonSubmitting={isPending}
      title={t('common:areYouSure')}
      variant="warning">
      <Typography>{t('settings:logo.removeLogoText')}</Typography>
    </Dialog>
  );
};

export default RemoveOrganizationLogoDialog;
